var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.goodsList),function(item,key){return _c('div',{key:key},[_vm._v("\n\t\t"+_vm._s(item)+"\n\t")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }